import React from 'react';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import { Container, Row, Col } from 'react-bootstrap';
import TypoContainer from '../../uikit/TypoContainer';
import Picture from '../Picture';

import type { Donate$key, Donate as IDonate } from './__generated__/Donate.graphql';
import './Donate.sass';

import LinkButton from '../../uikit/Links/LinkButton';
import Icropper from "../../interfaces/ICropper";

type Props = {
  donateData: Donate$key;
  label: string;
}

type UpdatedIDonate = Omit<IDonate, 'bottomSectionSidePicture'> & {bottomSectionSidePicture: Icropper | null}

const Donate: React.FC<Props> = (props) => {
  const data = useFragment(
    graphql`
			fragment Donate on HomePublishedContent {
				bottomSectionTitle
				bottomSectionSubtitle
				bottomSectionText
				bottomSectionSidePicture
				bottomSectionHide
				donateUrl
			}
		`,
    props.donateData
  ) as UpdatedIDonate;

  const {
    bottomSectionTitle,
    bottomSectionSubtitle,
    bottomSectionText,
    bottomSectionSidePicture,
    bottomSectionHide,
    donateUrl,
  } = data;

  return (
    <>
      {bottomSectionHide &&
        (<section className="donate">
            <Container>
              <Row>
                <Col xs={12} className="donate__heading">
                  <h2 className="uikit-heading-lg">{bottomSectionTitle}</h2>
                  <h3 className="uikit-heading-sm">{bottomSectionSubtitle}</h3>
                </Col>
                 <Col xs={12} md={bottomSectionSidePicture ? 7 : 12} className="donate__content">
                  {bottomSectionText && (
                    <TypoContainer
                      markup={bottomSectionText}
                    />
                  )}
                  {donateUrl && (
                    <LinkButton
                      id="support_btn"
                      isExternal
                      hrefSource={donateUrl}
                      label={props.label}
                    />
                  )}
                 </Col>
                {bottomSectionSidePicture && (
                  <Col
                    xs={12}
                    md={5}
                    lg={{ offset: 1, span: 4 }}
                    className="donate__image"
                  >
                    <Picture imageObj={bottomSectionSidePicture}/>
                  </Col>
                )}
              </Row>
            </Container>
          </section>
        )
      }
    </>
  );
}

export default Donate;
